import { render, staticRenderFns } from "./LocationHeader.vue?vue&type=template&id=6515f30c&lang=pug"
import script from "./LocationHeader.vue?vue&type=script&lang=coffee"
export * from "./LocationHeader.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports